import { AppState } from "features/state";

export const getPublishing = (state: AppState) => state.locations.publish.publishing;
